export default __webpack_public_path__ + "static/media/inbond-call.97679843.png";